const stripCurrencyFormat = (value) => value.toString().replace(/\..*/, '').replace(/[^0-9]/g, '')

export default stripCurrencyFormat


// WEBPACK FOOTER //
// ./src/utils/formatters/stripCurrencyFormat.js